module.exports = __webpack_public_path__ + "static/img/logo.9fcee095.png";